import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M16.504 2.25H7.5A5.25 5.25 0 0 0 2.25 7.5v9.004a5.246 5.246 0 0 0 5.246 5.246h9.008a5.246 5.246 0 0 0 5.246-5.245V7.496a5.246 5.246 0 0 0-5.246-5.246M12.5 7.75a.75.75 0 0 1 .75-.75c.414 0 .738.345.871.737.22.643.722 1.152 1.361 1.38.39.14.73.469.725.883s-.351.753-.753.652A4 4 0 0 1 14 9.917V14.5c0 1.648-1.352 3-3 3s-3-1.352-3-3c0-1.392.965-2.573 2.258-2.906.4-.103.742.242.742.656s-.356.733-.72.93c-.467.252-.78.745-.78 1.32 0 .838.662 1.5 1.5 1.5s1.5-.662 1.5-1.5z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }